// Generated from assets/icons/user-active.svg (TA-11013).
// Ids are derived per instance via useSvgIdPrefix() so two copies on one
// screen cannot collide. Edit this file rather than re-adding the .svg.
import * as React from 'react';
import Svg, { Path, Defs, LinearGradient, Stop } from 'react-native-svg';

import { useSvgIdPrefix } from '@hooks/useSvgIdPrefix';

import type { SvgProps } from 'react-native-svg';

export const UserActive = (props: SvgProps) => {
  const uid = useSvgIdPrefix();
  return (
    <Svg fill='none' viewBox='16.339 14.999 24 24' {...props}>
      <Path
        fill={`url(#${uid}-a)`}
        d='M28.338 28.111a5.556 5.556 0 1 0 0-11.111 5.556 5.556 0 0 0 0 11.111'
      />
      <Path
        fill={`url(#${uid}-b)`}
        d='M34.624 30.713a8.9 8.9 0 0 1 2.604 6.285H19.45a8.889 8.889 0 0 1 15.174-6.285'
      />
      <Defs>
        <LinearGradient
          id={`${uid}-a`}
          x1={24.727}
          x2={36.672}
          y1={18.389}
          y2={30.889}
          gradientUnits='userSpaceOnUse'>
          <Stop stopColor='#97D8C6' />
          <Stop offset={1} stopColor='#32866F' />
        </LinearGradient>
        <LinearGradient
          id={`${uid}-b`}
          x1={22.561}
          x2={30.003}
          y1={29.221}
          y2={44.796}
          gradientUnits='userSpaceOnUse'>
          <Stop stopColor='#97D8C6' />
          <Stop offset={1} stopColor='#32866F' />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};
